(ns practitest.frontend.common.keyboard
  (:require [practitest.frontend.common.bus :as bus]))

(defn ^:export trigger_shortcut_event
  "Integration entry point - see `app/assets/javascripts/keyboard_shortcuts.js`
   in `practitest-app` for usage"
  [event]
  (bus/publish :keyboard-shortcut event))
